import { useTranslation } from "react-i18next";
import convertText from "utils/convertText";
import Text from "components/typography/Text";
import Block from "components/layout/Block";

const DescriptionInfoMobileOldRefactored = ({ user }) => {
	const { t } = useTranslation(["userpanel"]);

	return (
		<Block flex column>
			{user.descriptionObject.plain ? (
				<Text size="1.25rem" bold>
					{t("userpanel:data.aboutMe")}
				</Text>
			) : null}
			<Text textBreak>
				{!user.descriptionObject?.isSpam
					? convertText({
							pieces: user.descriptionObject?.parsed,
					  })
					: user.descriptionObject?.cut}
			</Text>
		</Block>
	);
};

export default DescriptionInfoMobileOldRefactored;
